// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-1b9f78fc] {\n  -webkit-box-shadow: 0 0 20px 0 rgb(191, 217, 248);\n          box-shadow: 0 0 20px 0 rgb(191, 217, 248);\n  padding: 15px;\n  --bg-opacity: 1;\n  background-color: #ffffff;\n  background-color: rgba(255, 255, 255, var(--bg-opacity));\n  border-radius: 0.375rem;\n}", ""]);
// Exports
module.exports = exports;
